export default {
      id: "ic_stats-white-usage",
      viewBox: "0 0 23 25",
      url: "/" + "images/icons.3.109.2.svg#ic_stats-white-usage",
      toString: function () {
        return this.url;
      }
    }